import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { MessageService } from 'primeng/api';

@Injectable()
export class AppService extends BaseService {

  constructor(messageService: MessageService) {
    super(messageService);
  }
}
